module.exports = __webpack_public_path__ + "static/recursiveFactorial-888f88f789bee0286153d165fbeec4cc.png";